import React from 'react';
import _ from 'underscore';

import OverviewBoxes from './overview_boxes.jsx';

import { getTimeSpent } from '../../../helpers/studentReports';
import { requestGet, } from '../../../../../modules/request'
import { DataTable, Spinner, DataTableChip, accountGreenIcon, } from '../../../../Shared/index'
import ScoreColor from '../../modules/score_color';
import useScaledTableColumnWidths from '../../../../Shared/hooks/useScaledTableColumnWidths';

const DEFAULT_WIDTH = 240
const PLACEHOLDER_STRING = '—'

interface StudentInterface {
  name: string;
  score?: number;
  scoreText?: string;
  activity_classification?: string;
  activity_classification_name?: string;
  id?: number;
  time?: number;
  number_of_correct_questions?: number;
  number_of_questions?: number;
  concept_results?: any[];
  average_score_on_quill?: number;
  activity_session_id?: number;
  completed_at?: string;
}

const ClassReport = ({ match, }) => {
  const [students, setStudents] = React.useState<StudentInterface[]>(null)

  const containerRef = React.useRef<HTMLElement>(null);

  const columnWidths = useScaledTableColumnWidths({
    additionalWidthRestrictions: 34,
    columnWidths: [
      { minWidth: 150, width: DEFAULT_WIDTH },
      { minWidth: 110, width: DEFAULT_WIDTH },
      { minWidth: 90, width: DEFAULT_WIDTH },
      { minWidth: 90, width: DEFAULT_WIDTH },
      { minWidth: 145, width: 178 },
    ],
    containerRef,
    maxTableWidth: 1200,
    minTableWidth: 600,
  });

  const headers = [
    {
      name: 'Student Name',
      attribute: 'name',
      sortAttribute: 'lastName',
      width: columnWidths['240w-150min'],
      isSortable: true,
      rowSectionClassName: 'name'
    },
    {
      name: 'Score',
      attribute: 'score',
      sortAttribute: 'scoreNumber',
      width: columnWidths['240w-110min'],
      isSortable: true
    },
    {
      name: 'Time spent',
      attribute: 'timeSpent',
      sortAttribute: 'timeSpent',
      width: columnWidths['240w-90min'],
      isSortable: true
    },
    {
      name: 'Questions',
      attribute: 'numberOfQuestions',
      sortAttribute: 'numberOfQuestions',
      width: columnWidths['240w-90min'],
      isSortable: true
    },
    {
      name: 'Avg. score on Quill',
      attribute: 'averageScoreOnQuill',
      sortAttribute: 'averageScoreOnQuill',
      width: columnWidths['178w-145min'],
      isSortable: true
    },
  ]

  const { params, } = match
  const { unitId, activityId, classroomId, } = params

  React.useEffect(() => {
    requestGet(`/teachers/progress_reports/students_by_classroom/u/${unitId}/a/${activityId}/c/${classroomId}`, (response) => {
      const notCompletedStudents = response.not_completed_names.map(name => ({ name, scoreText: 'Not completed', }))
      const missedLessonStudents = response.missed_names.map(name => ({ name, scoreText: 'Missed lesson', }))
      const allStudents = response.students.concat(notCompletedStudents).concat(missedLessonStudents)
      setStudents(allStudents)
    })
  }, [])

  if (!students) {
    return (<div className="container"><Spinner /></div>)
  }

  function renderNameElement({ id, name, individualStudentReportLink }) {
    return (
      <DataTableChip
        icon={accountGreenIcon}
        label={name}
        link={id ? individualStudentReportLink : null}
      />
    )
  }

  const rows = students.map((student) => {
    const { name, score, id, time, number_of_questions, average_score_on_quill, scoreText, } = student

    const individualStudentReportLink = `/teachers/progress_reports/diagnostic_reports/u/${unitId}/a/${activityId}/c/${classroomId}/student_report/${id}`

    return {
      key: name,
      id: name,
      name: renderNameElement({ id, name, individualStudentReportLink }),
      lastName: name.split(' ')[1],
      score: scoreText || <span className={ScoreColor(score)}>{score ? `${score}%` : 'N/A'}</span>,
      scoreNumber: score,
      timeSpent: time ? getTimeSpent(time) : PLACEHOLDER_STRING,
      numberOfQuestions: number_of_questions || PLACEHOLDER_STRING,
      averageScoreOnQuill: average_score_on_quill ? `${average_score_on_quill}%` : PLACEHOLDER_STRING
    }
  })

  return (
    <main className="container class-report" ref={containerRef}>
      <OverviewBoxes data={students} />
      <DataTable
        className="reporting-format"
        defaultSortAttribute='scoreNumber'
        defaultSortDirection='descending'
        headers={headers}
        rows={rows}
      />
    </main>
  )
}

export default ClassReport
